import React from 'react';
import { useAdminData } from '../useAdminData';
import AuthorEditor from '../editors/AuthorEditor';

const AuthorPage = () => {
    const { formData, isLoading, isSaving, error, success, handleFormChange, handleSave } = useAdminData();

    const handleBioChange = (e) => {
        handleFormChange('author.bio', e.target.value.split('\n\n'));
    };

    if (isLoading) return <div>Betöltés...</div>;
    if (!formData) return <div>{error || "Hiba az adatok betöltésekor."}</div>;

    return (
        <div>
            <div className="admin-page-header">
                <h1>Szerzői Oldal</h1>
                <div>
                    {success && <span className="success-message">{success}</span>}
                    <button onClick={handleSave} className="save-button" disabled={isSaving}>
                        {isSaving ? 'Mentés...' : 'Mentés'}
                    </button>
                </div>
            </div>
            <AuthorEditor author={formData.author} onBioChange={handleBioChange} onFormChange={handleFormChange} />
        </div>
    );
};

export default AuthorPage;